import {FC} from 'react';
import {map, isEmpty} from 'lodash';
import {ValueRendererProps} from 'apstra-ui-common';

import FormattedPythonExpression from '../../pythonExpression/components/FormattedPythonExpression';

const ValueMap: FC<ValueRendererProps> = ({value}) => {
  if (isEmpty(value)) {
    return 'Empty';
  } else {
    return map(value, (value, key) =>
      <div key={key}>
        {key}{' ⟶ '}<FormattedPythonExpression value={value} />
      </div>
    );
  }
};

export default ValueMap;
